<template>
    <section>
        <div class="pro_section3" style="display: flex; position: relative; margin-bottom: 288px;">
            <div class="mobile_con_wrap" style="display: flex; flex-direction: column;">
                <div style="position: relative; display: flex; flex-direction: column; margin-bottom: 112px;">
                    <p style="font-size: 15px; font-weight: 700; color: white; text-align: left; color: #000000; margin-bottom: 8px;">
                        Mission & Vision
                    </p>
                    <div style="display: flex; align-items: flex-start; flex-direction: column; z-index: 1">
                        <p data-aos="fade-left"
                                data-aos-delay="100"
                                data-aos-once="true"
                                data-aos-duration="600"
                                data-aos-easing="ease-in-out" style="font-size: 25px; padding-bottom: 20px; font-weight: 700; color: white; text-align: center; color: #000000;">모두의 꿈</p>
                        <p data-aos="fade-left"
                                data-aos-delay="100"
                                data-aos-once="true"
                                data-aos-duration="600"
                                data-aos-easing="ease-in-out" style="font-size: 15px; font-weight: 400; line-height: 1.5; margin-bottom: 52px">
                            우리의 서비스를 통해 학생들이 공부에 집중할 수 있는 환경
                            이 조성되고 성공적인 입시를 해나갈 수 있도록, 모두가 꿈을
                            이룰 때까지 서비스를 만들어 나갑니다.
                        </p>
                        <p data-aos="fade-left"
                            data-aos-delay="100"
                            data-aos-once="true"
                            data-aos-duration="600"
                            data-aos-easing="ease-in-out" style="font-size: 25px; font-weight: 700; color: white; text-align: center; color: #000000; margin-bottom: 20px;">미래를 채울 때까지</p>
                        <p data-aos="fade-left"
                            data-aos-delay="100"
                            data-aos-once="true"
                            data-aos-duration="600"
                            data-aos-easing="ease-in-out" style="font-size: 15px; font-weight: 400; line-height: 1.5;">
                            사용자가 원하는 미래를 채울 때까지 우리는 정확하고 다양한
                            서비스를 제공하고, 다양한 컨텐츠를 통해서 차별화된 서비스
                            로 사용자에게 인정받는 플랫폼이 되겠습니다.
                        </p>
                    </div>
                </div>
                <p data-aos="fade-down"
                    data-aos-delay="100"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" 
                    data-aos-anchor-placement="center-bottom" style="font-size: 25px; font-weight: 700; color: white; text-align: center; color: #1C9CD3; margin-bottom: 49px;">
                    우리는 끊임없이 추구합니다
                </p>
                <div ref="circle" style="position: relative; display: flex; justify-content: center; height: 95px; padding: 0 10px">
                    <div v-for="(item, index) in pursuit" :key="index" 
                        :style="{
                            zIndex: 3 - index, 
                            left: moveCircle ? ((index != 0) ? ((index + 1) * 20) + (index * 10) + '%' : '20%') : '20%',
                            opacity: moveCircle ? 1 : ((index != 1) ? 0 : 1)}" 
                        style="position: absolute; display: flex; justify-content: center; align-items: center; width: 95px; height: 95px; border-radius: 100%; transform: translateX(-50%); border: 1px solid #1C9CD3; color: #1C9CD3; background: white; font-size: 18px; font-weight: 500; transition: all 0.3s ease;">{{item}}</div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    props: ['data'],
    components: {
        ChevronDownIcon,
    },
    data() {
        return {
            deltaY: 0,
            moveCircle: false,
            pursuit: [
                '정확함',
                '다양함',
                '신뢰감',
            ],

        }
    },
    computed: {
        scrollY() {
            return this.$store.state.scrollY
        },
        circle() {
            return this.$refs.circle
        },
    },
    methods: {
        handleScroll() {
            if(this.circle.getBoundingClientRect().top < (window.innerHeight - 100)) {
                if((this.scrollY - this.deltaY) > 0) {
                    this.moveCircle = true
                    console.log(this.moveCircle)
                } else {
                    // this.moveCircle = false
                    if(this.circle.offsetHeight < this.circle.getBoundingClientRect().top) {
                        this.moveCircle = false
                    }
                }
            } else {
                if((this.scrollY - this.deltaY) < 0) {
                    this.moveCircle = false
                }
            }
            this.deltaY = this.scrollY

        }
    },
    created() {
        document.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        document.removeEventListener('scroll', this.handleScroll)
    },    
}
</script>